module.exports = __webpack_public_path__ + "static/dev-portfolio-60fd6bf7623d648aa320d2804fe167f1.png";